import React from 'react';
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
import Error from "@material-ui/icons/Error";
import NotificationImportant from "@material-ui/icons/NotificationImportant";
import Warning from "@material-ui/icons/Warning";
// core components
import Snackbars from "components/Snackbar/Snackbar.jsx";

class Notification extends React.Component {
    constructor(props) {
        super(props);

        this.hideSelf = this.hideSelf.bind(this);
    }

    componentWillMount() {
        var id = setTimeout(function () {
            
            clearTimeout(id);
            if (this.props.data.show) {
                this.props.hide();
                const idx = setTimeout((() => { this.props.remove();clearTimeout(idx) }).bind(this), 1000);
            } else {
                this.props.remove();
            }
        }.bind(this), 6000);
        this.idx = id;
    }

    hideSelf() {
        clearTimeout(this.idx);
        this.props.hide();
        const idx = setTimeout((() => { this.props.remove(); clearTimeout(idx) }).bind(this), 1000);
    }

    
    render() {
        const { data } = this.props;
        
        var icon;
        switch (data.type) {
        case "primary":
        case "success":
                icon = AddAlert;
                break;
            case "danger":
                icon = Error;
                break;
            case "warning":
                icon =Warning;
                break;
            default:
                icon =NotificationImportant;
        }
        return (
            <Snackbars
                place={data.place}
                color={data.type}
                icon={icon}
                message={data.message}
                open={data.show}
                closeNotification={this.hideSelf}
                close
            />
        );
    }
}

export default Notification;


// WEBPACK FOOTER //
// ./src/erp/components/Notification.js